/**
 * draft-footer.js — DRAFT THEME ONLY.
 * Hides the native Warehouse footer and injects a custom footer with:
 *   - Trust strip (free shipping, returns, Canadian, real CS)
 *   - 4-column layout: About / Shop / Customer / Connect
 *   - Newsletter signup (posts to Shopify /contact form like native footer)
 *   - Social links (Instagram + TikTok), email, copyright, payment icons
 * All hrefs are CONFIRMED to exist on the live store.
 */
(function () {
  'use strict';
  if (document.getElementById('vr-footer')) return;

  var CSS = [
    '/* Hide the native Warehouse footer on draft (we replace it) */',
    'footer.footer[data-section-type="footer"] { display: none !important; }',
    /* Custom footer — light + on-brand */
    '#vr-footer {',
    '  background: #ffffff; color: #1e2d7d;',
    '  font-family: Barlow, system-ui, -apple-system, sans-serif;',
    '  margin-top: 32px;',
    '  padding: 0 0 calc(var(--vr-bnav-h, 60px) + env(safe-area-inset-bottom, 0px) + 12px);',
    '  border-top: 1px solid #e5e7eb;',
    '}',
    '#vr-footer a { color: #1e2d7d; text-decoration: none; transition: color 0.15s ease; }',
    '#vr-footer a:hover { color: #006fdb; }',
    /* Trust strip — keeps the brand-blue gradient (matches the announcement bar look) */
    '#vr-footer .vrf-trust { background: linear-gradient(135deg, #1e2d7d 0%, #006fdb 100%); padding: 18px 16px; }',
    '#vr-footer .vrf-trust-grid { max-width: 1280px; margin: 0 auto; display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; align-items: center; }',
    '#vr-footer .vrf-trust-item, #vr-footer a.vrf-trust-item { display: flex; align-items: center; gap: 10px; color: #ffffff !important; font-size: 13px; font-weight: 600; line-height: 1.25; text-decoration: none; }',
    '#vr-footer .vrf-trust-item svg { width: 24px; height: 24px; flex-shrink: 0; color: #ffd800; }',
    '@media (max-width: 767px) { #vr-footer .vrf-trust-grid { grid-template-columns: repeat(2, 1fr); gap: 14px 10px; } #vr-footer .vrf-trust-item { font-size: 12px; gap: 8px; } #vr-footer .vrf-trust-item svg { width: 20px; height: 20px; } }',
    /* Main footer body */
    '#vr-footer .vrf-body { max-width: 1280px; margin: 0 auto; padding: 40px 20px 28px; display: grid; grid-template-columns: 1.4fr 1fr 1fr 1.4fr; gap: 36px; }',
    '@media (max-width: 1023px) { #vr-footer .vrf-body { grid-template-columns: 1fr 1fr; gap: 28px; padding: 32px 20px 22px; } }',
    '@media (max-width: 559px) { #vr-footer .vrf-body { grid-template-columns: 1fr; gap: 24px; } }',
    '#vr-footer .vrf-col-title { font-size: 12px; font-weight: 800; letter-spacing: 1.4px; color: #006fdb; text-transform: uppercase; margin: 0 0 14px; padding-bottom: 8px; border-bottom: 2px solid #ffd800; display: inline-block; }',
    '#vr-footer .vrf-col-list { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 9px; }',
    '#vr-footer .vrf-col-list a { font-size: 14px; line-height: 1.4; color: #4a5570; }',
    '#vr-footer .vrf-col-list a:hover { color: #1e2d7d; text-decoration: underline; text-underline-offset: 3px; }',
    '#vr-footer .vrf-about-tag { font-size: 12px; color: #006fdb; font-weight: 800; letter-spacing: 1px; text-transform: uppercase; margin: 0 0 10px; padding-bottom: 8px; border-bottom: 2px solid #ffd800; display: inline-block; }',
    '#vr-footer .vrf-about-text { font-size: 13.5px; line-height: 1.6; color: #4a5570; margin: 0 0 14px; }',
    '#vr-footer .vrf-about-meta { font-size: 13px; line-height: 1.6; color: #4a5570; margin: 0; }',
    '#vr-footer .vrf-about-meta a { color: #1e2d7d; font-weight: 600; }',
    /* Newsletter */
    '#vr-footer .vrf-newsletter-form { display: flex; gap: 6px; margin-top: 4px; }',
    '#vr-footer .vrf-newsletter-input { flex: 1; min-width: 0; padding: 10px 12px; border-radius: 6px; border: 1px solid #d1d5db; background: #ffffff; color: #1e2d7d; font-size: 13.5px; font-family: inherit; }',
    '#vr-footer .vrf-newsletter-input:focus { outline: none; border-color: #006fdb; box-shadow: 0 0 0 2px rgba(0,111,219,0.15); }',
    '#vr-footer .vrf-newsletter-input::placeholder { color: #8e98b8; }',
    '#vr-footer .vrf-newsletter-btn { padding: 10px 16px; background: #ffd800; color: #1e2d7d; border: 0; border-radius: 6px; font-weight: 800; font-size: 13px; cursor: pointer; flex-shrink: 0; transition: background 0.15s ease, transform 0.1s ease; font-family: inherit; }',
    '#vr-footer .vrf-newsletter-btn:hover { background: #ffe340; }',
    '#vr-footer .vrf-newsletter-btn:active { transform: translateY(1px); }',
    '#vr-footer .vrf-newsletter-note { font-size: 11.5px; line-height: 1.5; color: #677279; margin: 10px 0 0; }',
    /* Social */
    '#vr-footer .vrf-social { display: flex; gap: 10px; margin-top: 18px; }',
    '#vr-footer .vrf-social a { width: 40px; height: 40px; display: inline-flex; align-items: center; justify-content: center; background: #f3f5f6; border: 1px solid #e5e7eb; border-radius: 50%; transition: all 0.18s ease; }',
    '#vr-footer .vrf-social a:hover { background: linear-gradient(135deg, #1e2d7d 0%, #006fdb 100%); border-color: transparent; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(30,45,125,0.25); }',
    '#vr-footer .vrf-social a:hover svg { color: #ffffff; }',
    '#vr-footer .vrf-social svg { width: 18px; height: 18px; color: #1e2d7d; transition: color 0.18s ease; }',
    /* Bottom bar */
    '#vr-footer .vrf-bottom { border-top: 1px solid #e5e7eb; padding: 16px 20px; max-width: 1280px; margin: 0 auto; display: flex; flex-wrap: wrap; gap: 14px; align-items: center; justify-content: space-between; }',
    '#vr-footer .vrf-copyright { font-size: 12px; color: #677279; margin: 0; }',
    '#vr-footer .vrf-bottom-links { display: flex; flex-wrap: wrap; gap: 14px; font-size: 12px; }',
    '#vr-footer .vrf-bottom-links a { color: #677279; }',
    '#vr-footer .vrf-bottom-links a:hover { color: #006fdb; }',
    '#vr-footer .vrf-payments { display: flex; gap: 6px; flex-wrap: wrap; }',
    '#vr-footer .vrf-payments span { height: 22px; min-width: 34px; padding: 0 5px; background: #ffffff; border: 1px solid #e5e7eb; border-radius: 3px; display: inline-flex; align-items: center; justify-content: center; font-size: 9px; font-weight: 700; color: #1e2d7d; line-height: 1; }',
    '@media (max-width: 559px) { #vr-footer .vrf-bottom { flex-direction: column; align-items: flex-start; padding: 14px 16px; } }'
  ].join('\n');

  var styleEl = document.createElement('style');
  styleEl.id = 'vr-footer-style';
  styleEl.textContent = CSS;
  document.head.appendChild(styleEl);

  function svgIcon(d, viewBox) {
    return '<svg viewBox="' + (viewBox || '0 0 24 24') + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  }

  var ICONS = {
    truck: svgIcon('<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>'),
    shield: svgIcon('<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 12 11 14 15 10"></polyline>'),
    leaf: svgIcon('<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19.2 2.96c1.4-.93 2.43-.96 3-.04 1.72 2.77.92 10.66-6.6 13.75-2.73 1.11-4.88 1.78-7.6 2.07"></path><path d="M2 21c0-3 1.85-5.36 5.08-6"></path>'),
    headset: svgIcon('<path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1v-7h3v5zM3 19a2 2 0 0 0 2 2h1v-7H3v5z"></path>'),
    instagram: svgIcon('<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>'),
    tiktok: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.96a8.16 8.16 0 0 0 5 1.7V7.7a4.85 4.85 0 0 1-2.07-1.01z"/></svg>',
    mail: svgIcon('<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>')
  };

  var html =
    '<div class="vrf-trust"><div class="vrf-trust-grid">' +
      '<div class="vrf-trust-item">' + ICONS.truck + '<span>Free shipping over $125 in Canada</span></div>' +
      '<a class="vrf-trust-item" href="/pages/onward-guarantee" style="text-decoration:none;color:#ffffff;">' + ICONS.shield + '<span>30-day money-back<br>(90-day with Onward)</span></a>' +
      '<div class="vrf-trust-item">' + ICONS.leaf + '<span>Canadian owned, shipped from Montreal</span></div>' +
      '<div class="vrf-trust-item">' + ICONS.headset + '<span>Real human customer service</span></div>' +
    '</div></div>' +

    '<div class="vrf-body">' +
      '<div class="vrf-col vrf-col--about">' +
        '<p class="vrf-about-tag">Top Nutrition & Fitness</p>' +
        '<p class="vrf-about-text">100% Canadian, women-owned since 2016. Premium supplements, protein snacks, and energy drinks — taste-tested by us, shipped fast from Montreal.</p>' +
        '<p class="vrf-about-meta">' +
          'Questions? <a href="mailto:info@topnutritionandfitness.com">info@topnutritionandfitness.com</a><br>' +
          '<a href="/pages/contact-us">Contact us</a> · <a href="/pages/about-top-nutrition-fitness">About</a>' +
        '</p>' +
      '</div>' +

      '<div class="vrf-col vrf-col--shop">' +
        '<p class="vrf-col-title">Shop</p>' +
        '<ul class="vrf-col-list">' +
          '<li><a href="/collections/new-arrivals">New Arrivals</a></li>' +
          '<li><a href="/collections/best-selling-snacks">Best Selling Snacks</a></li>' +
          '<li><a href="/collections/trending-products">Trending Products</a></li>' +
          '<li><a href="/collections/protein-snacks-1">Protein Snacks</a></li>' +
          '<li><a href="/collections/clearance">Clearance & Sales</a></li>' +
          '<li><a href="/pages/our-brands">All Brands</a></li>' +
          '<li><a href="/products/gift-card">Gift Cards</a></li>' +
        '</ul>' +
      '</div>' +

      '<div class="vrf-col vrf-col--help">' +
        '<p class="vrf-col-title">Customer Care</p>' +
        '<ul class="vrf-col-list">' +
          '<li><a href="/pages/faq">FAQ</a></li>' +
          '<li><a href="/policies/shipping-policy">Shipping Policy</a></li>' +
          '<li><a href="/pages/refund-policy">30-Day Returns</a></li>' +
          '<li><a href="/pages/how-sezzle-works">How Sezzle Works</a></li>' +
          '<li><a href="/pages/top-nutrition-fitness-rewards">Rewards Program</a></li>' +
          '<li><a href="/pages/wishlist">My Wishlist</a></li>' +
          '<li><a href="/account">My Account</a></li>' +
        '</ul>' +
      '</div>' +

      '<div class="vrf-col vrf-col--connect">' +
        '<p class="vrf-col-title">Stay Connected</p>' +
        '<form class="vrf-newsletter-form" method="post" action="/contact#footer-newsletter" id="vr-footer-newsletter" accept-charset="UTF-8">' +
          '<input type="hidden" name="form_type" value="customer">' +
          '<input type="hidden" name="utf8" value="\u2713">' +
          '<input type="hidden" name="contact[tags]" value="newsletter">' +
          '<input type="email" name="contact[email]" required placeholder="Your email" class="vrf-newsletter-input" aria-label="Email for newsletter">' +
          '<button type="submit" class="vrf-newsletter-btn">Subscribe</button>' +
        '</form>' +
        '<p class="vrf-newsletter-note">VIP emails — early access to new flavours, restocks, and members-only deals. Unsubscribe anytime.</p>' +
        '<div class="vrf-social">' +
          '<a href="https://instagram.com/topnutrition.andfitness" target="_blank" rel="noopener" aria-label="Instagram">' + ICONS.instagram + '</a>' +
          '<a href="https://www.tiktok.com/@topnutritionandfitness" target="_blank" rel="noopener" aria-label="TikTok">' + ICONS.tiktok + '</a>' +
          '<a href="mailto:info@topnutritionandfitness.com" aria-label="Email">' + ICONS.mail + '</a>' +
        '</div>' +
      '</div>' +
    '</div>' +

    '<div class="vrf-bottom">' +
      '<p class="vrf-copyright">© ' + new Date().getFullYear() + ' Top Nutrition & Fitness · Made in Montreal</p>' +
      '<div class="vrf-bottom-links">' +
        '<a href="/policies/privacy-policy">Privacy</a>' +
        '<a href="/policies/refund-policy">Refunds</a>' +
        '<a href="/policies/shipping-policy">Shipping</a>' +
        '<a href="/pages/data-sale-opt-out">Do not sell my info</a>' +
      '</div>' +
      '<div class="vrf-payments" aria-label="Accepted payment methods">' +
        '<span>VISA</span><span>MC</span><span>AMEX</span><span>APPL</span><span>GPAY</span><span>SHOP</span><span>SEZ</span>' +
      '</div>' +
    '</div>';

  var footer = document.createElement('footer');
  footer.id = 'vr-footer';
  footer.setAttribute('role', 'contentinfo');
  footer.innerHTML = html;

  function attach() {
    var nativeFooter = document.querySelector('footer.footer[data-section-type="footer"]');
    if (nativeFooter && nativeFooter.parentNode) {
      nativeFooter.parentNode.insertBefore(footer, nativeFooter.nextSibling);
    } else {
      document.body.appendChild(footer);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
